import { render, staticRenderFns } from "./ProductLibraryBuilder.vue?vue&type=template&id=65f7805c&scoped=true"
import script from "./ProductLibraryBuilder.vue?vue&type=script&lang=js"
export * from "./ProductLibraryBuilder.vue?vue&type=script&lang=js"
import style0 from "./ProductLibraryBuilder.vue?vue&type=style&index=0&id=65f7805c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f7805c",
  null
  
)

export default component.exports